<!-- <span class="fa hubtiger-print font-button float-right" pTooltip="{{
    'bikeshop.modal.update_job_card.job_card.print_this_job_card' | translate
  }}" tooltipZIndex="10000" tooltipPosition="left" (click)="printJobCard()"></span> -->
<div class="row margin-top-8">
  <div class="col-md-2 label">{{ "general.name" | translate }}:</div>
  <div class="col-md-3 value">
    <p-inplace #Name>
      <span pInplaceDisplay>
        {{ cyclist.Name }}
      </span>
      <span pInplaceContent>
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="cyclist.Name" (keyup.enter)="updateCyclist(Name, 'Name')"
                 (blur)="updateCyclist(Name, 'Name')"/>
          <span class="p-inputgroup-addon" (click)="updateCyclist(Name, 'Name')">
            <i class="fa fa-check"
               [ngClass]="{ red: cyclist.Name && cyclist.Name.length > 0 }"></i>
          </span>
        </div>
      </span>
    </p-inplace>
  </div>
  <div class="col-md-3 label">{{ "general.surname" | translate }}:</div>
  <div class="col-md-4 value">
    <p-inplace #Surname>
      <span pInplaceDisplay>
        {{ cyclist.Surname }}
      </span>
      <span pInplaceContent>
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="cyclist.Surname"
                 (keyup.enter)="updateCyclist(Surname, 'Surname')" (blur)="updateCyclist(Surname, 'Surname')"/>
          <span class="p-inputgroup-addon" (click)="updateCyclist(Surname, 'Surname')">
            <i class="fa fa-check"
               [ngClass]="{
               red: cyclist.Surname && cyclist.Surname.length>
              0
              }">
            </i>
          </span>
        </div>
      </span>
    </p-inplace>
  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">{{ "general.phone" | translate }}:</div>
  <div class="col-md-3 value">
    <p-inplace #phoneNumber>
      <span pInplaceDisplay>
        {{ cyclist.PhoneNumber }}
      </span>
      <span pInplaceContent>
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="cyclist.PhoneNumber"
                 (keyup.enter)="updateCyclist(phoneNumber, 'PhoneNumber')"
                 (blur)="updateCyclist(phoneNumber, 'PhoneNumber')"/>
          <span class="p-inputgroup-addon" (click)="updateCyclist(phoneNumber, 'PhoneNumber')">
            <i class="fa fa-check"
               [ngClass]="{
               red: cyclist.PhoneNumber && cyclist.PhoneNumber.length>
              0
              }">
            </i>
          </span>
        </div>
      </span>
    </p-inplace>
  </div>
  <div class="col-md-3 label">{{ "general.email" | translate }}:</div>
  <div class="col-md-4 value">
    <p-inplace #Email>
      <span pInplaceDisplay>
        {{ cyclist.Email }}
      </span>
      <span pInplaceContent>
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="cyclist.Email" (keyup.enter)="updateCyclist(Email, 'Email')"
                 (blur)="updateCyclist(Email, 'Email')"/>
          <span class="p-inputgroup-addon" (click)="updateCyclist(Email, 'Email')">
            <i class="fa fa-check" [ngClass]="{
                red:  validateEmail()
              }"></i>
          </span>
        </div>
      </span>
    </p-inplace>
  </div>
</div>

<div class="row margin-top-8" *ngIf="jobcard.IsFitting">
  <div class="col-md-2 label">{{ "general.date_of_birth" | translate }}:</div>
  <div class="col-md-3 value">
    <p-calendar [(ngModel)]="cyclist.DateOfBirth" dateFormat="{{countryData.DatePickerFormat}}"
                [yearNavigator]="true" yearRange="1900:2020" (onSelect)="updateCyclist(null, 'DateOfBirth')"
                [showTime]="false"></p-calendar>
  </div>
</div>

<div class="row margin-top-8">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.scheduled_date" | translate }}:
  </div>
  <div class="col-md-3 value">
    <p-calendar [(ngModel)]="jobcard.DateCheckedIn" dateFormat="{{countryData.DatePickerFormat}}"
                (onSelect)="changeServiceDate()"
                [stepMinute]="15" [showTime]="true" hourFormat="{{setCalendarTimeFormat}}"></p-calendar>
  </div>
  <div class="col-md-3 label">
    {{ "bikeshop.modal.update_job_card.job_card.required_by" | translate }}:
  </div>
  <div class="col-md-4 value">
    <!-- {{
      jobcard.DateRequiredBy
        ? (jobcard.DateRequiredBy | date: "yyyy-MM-dd")
        : "N/A"
    }} -->
    <p-calendar [(ngModel)]="jobcard.DateRequiredBy" [minDate]="jobcard.DateCheckedIn"
                dateFormat="{{countryData.DatePickerFormat}}"
                (onSelect)="changeRequiredDate()" [stepMinute]="5" [showTime]="true"
                hourFormat="{{setCalendarTimeFormat}}"></p-calendar>
  </div>
</div>
<div class="row margin-top-8" *ngIf="!isOriginalDate() && isValidDate()">
  <div class="col-md-5"></div>
  <div class="orange col-md-3 label">
    {{ "bikeshop.modal.update_job_card.job_card.original_date" | translate }}:
  </div>
  <div class="col-md-4 value orange">{{ (jobcard.OriginalBookInDate | DateFormatPipe: displayDateTimeFormat) }}</div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">{{ "general.technician" | translate }}:</div>
  <div class="col-md-3 value">
    <!-- {{ jobcard.TechnicianDescription }} -->
    <p-inplace #cyclistName>
      <span pInplaceDisplay>
        {{ jobcard.TechnicianDescription }}
      </span>
      <span pInplaceContent>
        <p-dropdown [options]="technicians" [(ngModel)]="jobcard.TechnicianID" (onChange)="updateTechnician()">
        </p-dropdown>
      </span>
    </p-inplace>
  </div>
  <div class="col-md-3 label">
    {{ "bikeshop.modal.update_job_card.job_card.duration" | translate }}:
  </div>
  <div class="col-md-4 value">
    {{ jobcard.Duration }} {{ "general.minutes" | translate }}
  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">{{ "general.bike" | translate }}:</div>
  <div class="col-md-3 value">
    <p-inplace #bikeName>
      <span pInplaceDisplay>
        {{ jobcard.BikeDescription }} {{jobcard.BikeType ? (' (' + (jobcard.BikeType | translate) + ')') : ''}}
      </span>
      <span pInplaceContent>
        <p-dropdown [options]="bikes" [(ngModel)]="jobcard.BikeID" (onChange)="updateBike()">
        </p-dropdown>
      </span>
    </p-inplace>
  </div>
  <div class="col-md-3 label">
    <div>
      <span>{{ "bikeshop.modal.shared.bike.serial_no" | translate }}:</span>          
    </div>
  </div>
  <div class="col-md-4 value">
    <div class="serial-number">
      <span 
        class="project529" 
        pTooltip="{{(jobcard.project529.status == 'Stolen' ? 'bikeshop.modal.update_job_card.project_529.stolen_message' : jobcard.project529.status == 'Registered' ? 'bikeshop.modal.update_job_card.project_529.registered_message' : 'bikeshop.modal.update_job_card.project_529.not_registered_message') | translate}}"
        [ngStyle]="{'cursor':jobcard.project529.status != 'Registered' ? 'pointer' : 'default'}" 
        *ngIf="jobcard.project529 && jobcard.project529.status" 
        (click)="project529Action(jobcard.project529)">
        <!-- <img src="./assets/project529/logo_2.png" > -->
        <div class="common stolen1" *ngIf="jobcard.project529.status == 'Stolen'"><daz-icon name="light_emergency_on_duo" [size]="'18px'" color="#f8312f"></daz-icon></div>
        <div class="common registered1" *ngIf="jobcard.project529.status == 'Registered'"><daz-icon name="shield_check_duo" [size]="'18px'" color="#00d26a"></daz-icon></div>
        <div class="common not-registered1" *ngIf="jobcard.project529.status == 'Not Registered'"><daz-icon name="shield_slash_duo" [size]="'18px'" color="#ff8400"></daz-icon></div>
      </span>
      <span>{{ jobcard.SerialNo }}</span>
    </div>    
  </div>
  <!--<div class="col-md-3 label">
    {{ "bikeshop.modal.update_job_card.job_card.price_estimate" | translate }}:
  </div>
  <div class="col-md-4 value">
    {{ currencySymbol }}{{ jobcard.PriceEstimate }}
  </div>-->
</div>
<div class="row margin-top-8" *ngIf="!jobcard.IsFitting">
  <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.bike_is_here" | translate }}:</div>
  <div class="col-md-3 value">
    <p-inputSwitch [ngModel]="jobcard.BikeIsHere" (onChange)="updateBikeIsHere($event)"
                   [disabled]="jobStatus >= 25 && jobStatus != 35"></p-inputSwitch>
  </div>
  <div class="col-md-3 label">
    {{ "bikeshop.modal.shared.bike.bay_tag_number" | translate }}:
  </div>
  <div class="col-md-4 value">
    <p-inplace #BikeBay>
      <span pInplaceDisplay>
        {{ jobcard.BikeBay }}
      </span>
      <span pInplaceContent>
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="jobcard.BikeBay" (keyup.enter)="updateBikeBay(BikeBay)"
                 (blur)="updateBikeBay(BikeBay)"/>
          <span class="p-inputgroup-addon" (click)="updateBikeBay(BikeBay)"><i class="fa fa-check"></i></span>
        </div>
      </span>
    </p-inplace>
  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.booked_in_by" | translate }}:
  </div>
  <div class="col-md-3 value">
    <div *ngIf="jobcard.CreatedBy == -1 || jobcard.CreatedBy == jobcard.CyclistID || !partnerData.CreatedByOverrideOnBooking">{{ jobcard.CreatedBy == -1 ? ('bikeshop.modal.update_job_card.job_card.widget' | translate) : jobcard.CreatedBy == jobcard.CyclistID ? ('bikeshop.modal.update_job_card.job_card.app' | translate) : jobcard.CreatedByName }}</div>    
    <div *ngIf="!(jobcard.CreatedBy == -1 || jobcard.CreatedBy == jobcard.CyclistID) && partnerData.CreatedByOverrideOnBooking">
      <p-inplace #BookedInBy>
        <span pInplaceDisplay>
          {{ jobcard.CreatedByName }}
        </span>
        <span pInplaceContent>
          <p-dropdown [options]="systemUsers" [(ngModel)]="jobcard.CreatedBy" (onChange)="updateBookedInBy()">
          </p-dropdown>
        </span>
      </p-inplace>
    </div>
  </div>
</div>
<div class="row margin-top-8" *ngIf="serviceTypes && serviceTypes.length > 0">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.service_type" | translate }}:
  </div>
  <div class="col-md-10 value">
    <p-multiSelect #serviceTypeDropDown [options]="serviceTypes" [(ngModel)]="selectedServiceTypes" [filter]="true"
                   [showHeader]="true" filterBy="search,reverseSearch" scrollHeight="380px"
                   [resetFilterOnHide]="true" autofocus="true"
                   [optionLabel]="'label'"
                   [optionValue]="'value'"
                   [showToggleAll]="false" (ngModelChange)="updateServiceTypes()"
                   [disabled]="jobcard.StatusID === checkDisabled">
    </p-multiSelect>
  </div>
</div>
<div *ngIf="showThirdParties == true">
  <div class="row margin-top-8">
    <div class="col-md-2 label">
      {{ "bikeshop.modal.shedule_service.thirdparty" | translate }}:
    </div>
    <div class="col-md-10">
      <p-dropdown [options]="thirdParties" [(ngModel)]="selectedThirdParty"
                  placeholder="{{ 'general.choose' | translate }}"
                  (ngModelChange)="updateServiceTypes()"></p-dropdown>
    </div>
  </div>

  <div class="row margin-top-8" *ngIf="selectedThirdParty != null">
    <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.thirdparty_responsibleforpayment' | translate}}
      :
    </div>
    <div class="col-md-10">
      <p-inputSwitch [(ngModel)]="selectedThirdPartyIsResponsibileForPayment"
                     [disabled]="selectedThirdParty == null" (onChange)="updateServiceTypes()"></p-inputSwitch>
    </div>
  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.customer_notes" | translate }}:
  </div>
  <div class="col-md-10 value">
    <i *ngIf="!editClientNotes">
      <div [innerHTML]="jobcard.Client_Notes || '-'"></div>
      <div class="fa hubtiger-edit font-button" (click)="startEditClientNote()"></div>
    </i>
    <div *ngIf="editClientNotes">
      <div class="p-inputgroup">
                <textarea [rows]="5" pInputTextarea [(ngModel)]="jobcard.Client_Notes"
                          (blur)="updateClientNote()"></textarea>
        <span class="p-inputgroup-addon" (click)="updateClientNote()"><i class="fa fa-check red"></i></span>
      </div>
    </div>

  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.internal_note" | translate }}:
  </div>
  <div class="col-md-10 value">
    <div class="p-inputgroup">
      <textarea [rows]="internalNotesRows" pInputText [(ngModel)]="internalNote" (blur)="addInternalNote()"
                placeholder="{{
          'bikeshop.modal.update_job_card.job_card.add_internal_note'
            | translate
        }}" (focus)="setInternalNotesRows()" (focusout)="resetInternalNotesRows()"
                (keydown.Tab)="preventDefaultTab($event)"></textarea>
      <span class="p-inputgroup-addon" (click)="addInternalNote()">
        <i class="fa fa-check" [ngClass]="{
           red: internalNote && internalNote.length>
          0
          }">
        </i>
      </span>
    </div>
  </div>
</div>
<div class="row margin-top-8" *ngIf="jobcard.PostServiceInspection_Notes || editInternalNote">
  <div class="col-md-2 label"></div>
  <div class="col-md-10 value">
    <i *ngIf="!editInternalNote">
      <div [innerHTML]="jobcard.PostServiceInspection_Notes"></div>
      <div class="fa hubtiger-edit font-button" (click)="startEditInternalNote()"></div>
    </i>
    <div *ngIf="editInternalNote">
      <div class="p-inputgroup">
                <textarea [rows]="5" pInputTextarea [(ngModel)]="jobcard.PostServiceInspection_Notes"
                          (blur)="updateInternalNote()"></textarea>
        <span class="p-inputgroup-addon" (click)="updateInternalNote()"><i class="fa fa-check red"></i></span>
      </div>
    </div>
  </div>
</div>
<div class="row margin-top-8">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.assessment_note" | translate }}:
  </div>
  <div class="col-md-10 value">
    <div class="p-inputgroup">
      <textarea [rows]="externalNotesRows" type="text" pInputText [(ngModel)]="assessmentNote"
                (blur)="addAssessmentNote()" placeholder="{{
          'bikeshop.modal.update_job_card.job_card.add_assessment_note'
            | translate
        }}" (focus)="setExternalNotesRows()" (focusout)="resetExternalNotesRows()"
                (keydown.Tab)="preventDefaultTab($event)"></textarea>
      <span class="p-inputgroup-addon" (click)="addAssessmentNote()">
        <i class="fa fa-check" [ngClass]="{
           red: assessmentNote && assessmentNote.length>
          0
          }">
        </i>
      </span>
    </div>
  </div>
</div>
<div class="row margin-top-8" *ngIf="jobcard.InitialAssesment_Notes || editAssessmentNote">
  <div class="col-md-2 label"></div>
  <div class="col-md-10 value">
    <i *ngIf="!editAssessmentNote">
      <div [innerHTML]="jobcard.InitialAssesment_Notes"></div>
      <div class="fa hubtiger-edit font-button" (click)="startEditAssessmentNote()"></div>
    </i>
    <div *ngIf="editAssessmentNote">
      <div class="p-inputgroup">
                <textarea [rows]="5" pInputTextarea [(ngModel)]="jobcard.InitialAssesment_Notes"
                          (blur)="updateAssessmentNote()"></textarea>
        <span class="p-inputgroup-addon" (click)="updateAssessmentNote()"><i
          class="fa fa-check red"></i></span>
      </div>
    </div>
  </div>
</div>

<div class="row margin-top-8" *ngIf="jobcard.HearAbout && jobcard.HearAbout.length > 0">
  <div class="col-md-2 label">{{ "general.how_did_you_hear_about_us" | translate }}:</div>
  <div class="col-md-3 value">
    {{ jobcard.HearAbout }}
  </div>
</div>

<div class="row margin-top-8">
  <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.send_communication" | translate }}:</div>
  <div class="col-md-10 value" style="display: flex;align-items: center;">
    <p-inputSwitch [(ngModel)]="sendComms"></p-inputSwitch>
    <small
      style="margin-left: 16px;">{{ "bikeshop.modal.update_job_card.job_card.send_communication_info" | translate }}</small>
  </div>
</div>

<!-- <div class="row margin-top-8" *ngIf="showGDPRMarketingConsent == true && userGaveGDPRMarketingConsent == false">
  <div class="col-md-2 label" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
    {{
    'bikeshop.modal.update_job_card.job_card.showgdprconsent' | translate
    }}:
  </div>
  <div class="col-md-10" style="display: flex;align-items: center;">
    <p-inputSwitch [(ngModel)]="consentForMarketing" (onChange)="updateMarketingConsent()"></p-inputSwitch>
    <small style="
        margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;
      ">
      {{
        "bikeshop.modal.update_job_card.job_card.showgdprconsent_info" | translate
      }}
    </small>
  </div>
</div> -->

<div id="cannotComplete" class="row margin-top-8" *ngIf="CompleteJobCardTasks.length > 0">
  <div
    class="col-md-12 label mandatory-tasks-header">{{'bikeshop.checklist.complete_mandatory_checklist_items' | translate }}</div>
  <ul>
    <ng-container *ngFor="let action of CompleteJobCardTasks">
      <li class="col-md-12 value">
        {{action}}
      </li>
    </ng-container>
  </ul>
</div>
<div class="row margin-top-8" *ngIf="jobcard.StatusID < 40">
  <div class="col-md-2 label">{{ "general.status" | translate }}:</div>
  <div class="col-md-10 value">
    <div class="status-container">
      <div *ngFor="let action of jobActions">
        <div class="status-item" [ngClass]="{ active: action.id === jobStatus }" (click)="updateStatus(action)"
             *ngIf="(action.id === 20 && jobcard.StatusID === 15 && action.key === 15) || (action.id === 20 && jobcard.StatusID > 15 && action.key === 20) || ((action.id !== 20 && action.id !== 40) || (action.id === 40 && !showUndo && canCompleteJobCard)) ">
          <div>{{ action.label }}</div>
        </div>
        <div class="status-item inactive" *ngIf="action.id === 40 && !canCompleteJobCard"
             style="cursor:not-allowed;">
          <div (mouseenter)="alertToDos()" (mouseleave)="stopAlertToDos()">{{ action.label }}</div>
        </div>
        <div class="status-item undo" (click)="undoCompletionTask()" *ngIf="action.id === 40 && showUndo">
          <div>{{ 'bikeshop.modal.update_job_card.job_card.undo_completion' | translate}} ({{countDownValue}}
            )
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row margin-top-8" *ngIf="TransferredFrom">
  <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.transferred_from" | translate }}:</div>
  <div class="col-md-10 value">
    {{ TransferredFrom }}
  </div>
</div>

<div class="row margin-top-8" *ngIf="canMoveJobCard && !showMoveJobcardDialog">
  <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.move_jobcard" | translate }}:</div>
  <div class="col-md-3 value">
    <div class="status-container">
      <div class="status-item" (click)="showMoveDialog()">
        <div>{{'bikeshop.modal.update_job_card.job_card.move_jobcard' | translate}}</div>
      </div>
    </div>
  </div>
</div>


<div class="row margin-top-8" *ngIf="jobcard.StatusID === 45 || jobcard.StatusID === 40">
  <div class="col-md-3">
    <button pButton type="button" [disabled]="busySaving" class="p-button-raised full-width" label="{{
        'bikeshop.modal.update_job_card.job_card.bike_collected' | translate
      }}" (click)="bikeCollected()"></button>
  </div>
  <div class="col-md-3">
    <div
      *ngIf="jobcard.StatusID !== 100 && partnerData.ShowComplaintFlag && partnerData.ComplaintSlackChannel && partnerData.ComplaintSlackChannel.length > 0">
      <button pButton type="button" [disabled]="submittingComplaint || jobcard.ComplaintFlagged"
              class="p-button-raised  full-width" label="{{
        'bikeshop.modal.update_job_card.job_card.complaint_received' | translate
      }}" (click)="compaintReceived()"></button>
    </div>
  </div>
  <div class="col-md-3"></div>
  <div class="col-md-3">
    <button pButton type="button" [disabled]="busySaving" class="p-button-raised accent  full-width" label="{{
        'bikeshop.modal.update_job_card.job_card.reopen_job_card' | translate
      }}" (click)="reopenJobCard()"></button>
  </div>
  <!-- <div class="col-md-3">
    <button
        pButton
        type="button"
        [disabled]="busySaving"
        class="p-button-raised alternate full-width"
        label="Ready For Drop Off"
        (click)="bikeCollected()"
      ></button>
    </div> -->
</div>

<div class="row margin-top-8" *ngIf="jobcard.StatusID === 41">
  <div class="col-md-3">
  </div>
  <div class="col-md-3">
  </div>
  <div class="col-md-3"></div>
  <div class="col-md-3">
    <button pButton type="button" [disabled]="busySaving" class="p-button-raised accent  full-width" label="{{
        'bikeshop.modal.update_job_card.job_card.reopen_job_card' | translate
      }}" (click)="reopenJobCard()"></button>
  </div>

</div>

<div class="row margin-top-8" *ngIf="jobcard.StatusID > 45">
  <!-- This complaint button is specifically for Fettle, just tied it to a slack channel thats in the table -->
  <div class="col-md-3">
    <div
      *ngIf="jobcard.StatusID !== 100 && partnerData.ShowComplaintFlag && partnerData.ComplaintSlackChannel && partnerData.ComplaintSlackChannel.length > 0">
      <button pButton type="button" [disabled]="submittingComplaint || jobcard.ComplaintFlagged"
              class="p-button-raised  full-width" label="{{
    'bikeshop.modal.update_job_card.job_card.complaint_received' | translate
  }}" (click)="compaintReceived()"></button>
    </div>
  </div>
  <div class="col-md-3"></div>
  <div class="col-md-3"></div>
  <div class="col-md-3" *ngIf="!isTesting()">
    <button pButton type="button" [disabled]="busySaving" class="p-button-raised accent  full-width" label="{{
        'bikeshop.modal.update_job_card.job_card.reopen_job_card' | translate
      }}" (click)="reopenJobCard()"></button>
  </div>
  <!-- <div class="col-md-3">
    <button
        pButton
        type="button"
        [disabled]="busySaving"
        class="p-button-raised alternate full-width"
        label="Ready For Drop Off"
        (click)="bikeCollected()"
      ></button>
    </div> -->
</div>
<div class="row margin-top-8" *ngIf="jobCancelled && jobStatus === 100">
  <div class="col-md-2 label">
    {{ "bikeshop.modal.update_job_card.job_card.cancel_reason" | translate }}:
  </div>
  <div class="col-md-10 value">
    <p-dropdown [options]="cancellationreasons" [(ngModel)]="selectedCancellationReason" placeholder="{{
        'bikeshop.modal.update_job_card.job_card.select_a_cancellation_reason'
          | translate
      }}" (ngModelChange)="beginJobCancellation()"></p-dropdown>
  </div>
</div>
<div class="row margin-top-8" *ngIf="jobCancelled && jobStatus === 100 && showCancellationOtherReason">
  <div class="col-md-2 label">
    {{ "bikeshop.cancellation_reason.specify_reason" | translate }}:
  </div>
  <div class="col-md-10 value">
    <input pInputText type="text" [(ngModel)]="cancellationOtherReason" (keyup.enter)="cancelJob()"/>
  </div>
</div>
<div class="row margin-top-8" *ngIf="jobCancelled && jobStatus === 100 && showCancellationOtherReason">
  <div class="col-md-9"></div>
  <div class="col-md-3">
    <button pButton type="button" [disabled]="cancellationOtherReason.trim().length < 5 || busySaving"
            class="p-button-raised accent  full-width" label="{{
        'bikeshop.job_actions.cancel_job' | translate
      }}" (click)="cancelJob()"></button>
  </div>
</div>


<div class="row margin-top-8" *ngIf="busySaving">
  <div class="col-md-2 label"></div>
  <div class="col-md-10 value">
    <div>
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s">
      </p-progressSpinner>
    </div>
  </div>
</div>

<div class="row margin-top-8"
     *ngIf="jobcard.StatusID < 40 && partnerData.ShowComplaintFlag && partnerData.ComplaintSlackChannel && partnerData.ComplaintSlackChannel.length > 0">
  <div class="col-md-3">
    <div
      *ngIf="partnerData.ShowComplaintFlag && partnerData.ComplaintSlackChannel && partnerData.ComplaintSlackChannel.length > 0">
      <button pButton type="button" [disabled]="submittingComplaint || jobcard.ComplaintFlagged"
              class="p-button-raised  full-width" label="{{
          'bikeshop.modal.update_job_card.job_card.complaint_received' | translate
        }}" (click)="compaintReceived()"></button>
    </div>
  </div>
  <div class="col-md-9"></div>
</div>
<div *ngIf="jobcard.PaidWithStripe" class="paid-with-stripe">
  <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with" | translate }}</span>
  <span class="icon fa fa-cc-stripe"></span>
</div>
<div *ngIf="jobcard.PaidWithPOS" class="paid-with-pos">
  <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with_pos" | translate }}</span>
</div>
<p-confirmDialog key="jobcard"></p-confirmDialog>
<p-dialog header="{{ 'bikeshop.modal.update_job_card.job_card.move_jobcard' | translate }}"
          [(visible)]="showMoveJobcardDialog" [modal]="true" [responsive]="true" [style]="{width: '600px'}"
          [contentStyle]="{'overflow':'visible', 'height': 'inherit'}" *ngIf="canMoveJobCard && serviceTypes.length>0">
  <app-move-jobcard [messageService]="messageService" [jobcard]="jobcard" [partnerID]="partnerID"
                    (jobCardMoved)="jobCardMoved($event)" (showMoveJobcardDialog)="closeMoveJobcardDialog()"
                    [otherShops]="otherShops"
                    [originalServiceTypes]="selectedServiceTypes"
                    [originalServiceTypeNames]="serviceTypes"></app-move-jobcard>
</p-dialog>
